export default __webpack_public_path__ + "static/media/df (2).acc6ae39.png";